import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Popover from 'material-ui/Popover';
import find from 'lodash/find';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import RuleFields from './RuleFields/RuleFields';
import DateTimePicker from './DateTimePicker';
import SlateSelect from 'components/Shared/SlateSelect';
import SlateTextInput from 'components/Shared/SlateTextInput';
import {
  ruleParts,
  fieldsTypes,
  dynamicDate,
  entityNames,
  entryDetailsTypes,
  entryDetails,
} from 'config/constants';
import { getBooleanText } from 'helpers/fieldsHelper';
import { getTimestampFromDate } from 'helpers/dateTimeHelper';
import { checkPatternExist } from 'helpers/fieldsHelper';
import tryMe from 'helpers/tryMe';
import './style.css';
import CircularIndeterminate from "./Loader";
import cx from "classnames";

class Rule extends Component {
  static propTypes = {
    rule: PropTypes.object.isRequired,
    fields: PropTypes.array.isRequired,
    onRuleChange: PropTypes.func.isRequired,
    onRemoveRule: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      isFieldsPopoverOpen: false,
      currentField: {title: ''},
    };
    this.fieldSelector = React.createRef();
  }

  UNSAFE_componentWillMount() {
    var rule = this.props.rule;
    var fields = this.props.fields;
    var allFields = this.props.allFields;
    var fieldSUUID = rule[ruleParts.FIELD_SUUID] || rule[ruleParts.RECORD_ENTRY_ATTRIBUTE];
    if (fieldSUUID && fields.length) {
      this.findCurrentField(rule, allFields);
    }
  }

  UNSAFE_componentWillReceiveProps = function(nextProps) {
    var rule = this.props.rule;
    var fields = this.props.fields;
    var ruleNextProps = nextProps.rule;
    var fieldsNextProps = nextProps.fields;
    var allFieldsNextProps = nextProps.allFields;

    var fieldSUUID = rule && (
      rule[ruleParts.FIELD_SUUID] ||
      rule[ruleParts.RECORD_ENTRY_ATTRIBUTE]
    );
    var fieldSUUIDNextProps = ruleNextProps && (
      ruleNextProps[ruleParts.FIELD_SUUID] ||
      ruleNextProps[ruleParts.RECORD_ENTRY_ATTRIBUTE]
    );

    if (
      ((fieldSUUIDNextProps !== fieldSUUID) && fieldsNextProps && fieldsNextProps.length) ||
      ((fieldsNextProps !== fields) && fieldSUUIDNextProps)
    ) {
      this.findCurrentField(ruleNextProps, allFieldsNextProps);
    }
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handlePageScroll, true);
    window.removeEventListener('wheel', this.handlePageScroll, true);
  }

  findCurrentField(rule, fields) {
    var currentField;
    if (rule[ruleParts.RECORD_ENTRY_ATTRIBUTE]) {
      currentField = {...rule, title: entryDetails[rule[ruleParts.RECORD_ENTRY_ATTRIBUTE]].title};
    } else {
      currentField = find(fields, function(item) { return item.suuid === rule[ruleParts.FIELD_SUUID]; }) || '';
    }
    this.setState({currentField: currentField});
  }

  render() {
    var self = this;
    var rule = this.props.rule;
    var settingsOperators = this.props.settingsOperators;
    var t = this.props.t;
    var onRemoveRule = this.props.onRemoveRule;
    var activeRule = this.props.activeRule;
    var isRecordListView = this.props.isRecordListView;
    var allFields = this.props.allFields;
    var recordsFieldUniquenessIdentifier = this.props.recordsFieldUniquenessIdentifier;
    var fields = this.props.fields;
    var disabled = this.props.disabled;
    var hideEntryDetails = this.props.hideEntryDetails;
    var hideOtherFields = this.props.hideOtherFields;

    var isFieldsPopoverOpen = this.state.isFieldsPopoverOpen;
    var anchorEl = this.state.anchorEl;
    var currentField = this.state.currentField;

    var fieldSUUID = rule[ruleParts.RECORD_ENTRY_ATTRIBUTE] || rule[ruleParts.FIELD_SUUID];
    var operator = rule[ruleParts.OPERATOR];
    var pattern = rule[ruleParts.PATTERN];

    var isPatternExist = checkPatternExist(operator);
    var loading = this.props.operatorsEntity && this.props.operatorsEntity.isFetching;

    // Build operator options for SlateSelect
    var operatorOptions = [];
    if (fieldSUUID && settingsOperators && settingsOperators[fieldSUUID]) {
      var allowedOperators = settingsOperators[fieldSUUID].allowedOperators || [];
      operatorOptions = allowedOperators.map(function(op) {
        return { value: op, text: t('settings:' + op) };
      });
    }

    return (
      <div className="settings-rule-content-container">
        {loading && this.props.rule.uuid === activeRule &&
          <CircularIndeterminate />
        }
        <div className={cx('settings-rule', {
          'blur': loading && this.props.rule.uuid === activeRule,
        })}>
          <div className="settings-rule-items-container">
            {/* Field Selector */}
            <div className="settings-rule-field" id={'rule-' + rule.uuid}>
              <button
                ref={this.fieldSelector}
                type="button"
                className="settings-rule-field-trigger"
                onClick={this.handleFieldClick}
                disabled={disabled}
              >
                <span className={currentField && currentField.title ? 'settings-rule-field-value' : 'settings-rule-field-placeholder'}>
                  {currentField && currentField.title ? currentField.title : t('settings:selectField')}
                </span>
                <span className="settings-rule-field-chevron">
                  <span className="material-symbols-outlined">expand_more</span>
                </span>
              </button>

              <Popover
                open={isFieldsPopoverOpen}
                anchorEl={anchorEl}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                onRequestClose={this.handleFieldClose}
                className="field-selector-popover"
                useLayerForClickAway={false}
                zDepth={0}
                style={{
                  marginTop: 8,
                  background: 'transparent',
                  boxShadow: 'none',
                  overflow: 'visible',
                  borderRadius: 12,
                }}
              >
                <RuleFields
                  allFields={allFields}
                  recordsFieldUniquenessIdentifier={recordsFieldUniquenessIdentifier}
                  isRecordListView={isRecordListView}
                  fields={fields}
                  onFieldClick={this.handleFieldChange}
                  hideEntryDetails={hideEntryDetails}
                  hideOtherFields={hideOtherFields}
                />
              </Popover>
            </div>

            {/* Operator Selector */}
            {fieldSUUID && settingsOperators && settingsOperators[fieldSUUID] && (
              <div className="settings-rule-operator">
                <SlateSelect
                  options={operatorOptions}
                  value={operator}
                  onChange={this.handleOperatorChange}
                  placeholder={t('settings:selectOperator')}
                  searchable={false}
                  disabled={disabled}
                />
              </div>
            )}

            {/* Pattern Input */}
            {fieldSUUID &&
              settingsOperators &&
              settingsOperators[fieldSUUID] &&
              operator &&
              isPatternExist &&
              this.renderPatternComponent(
                pattern,
                currentField,
                operator,
                tryMe(tryMe(settingsOperators)[fieldSUUID]).showTime,
              )}
          </div>

          <div className="settings-rule-btn-remove">
            <button
              type="button"
              className="settings-rule-remove-btn"
              onClick={function() { onRemoveRule(rule.uuid); }}
              disabled={disabled}
            >
              <i className="material-icons">close</i>
            </button>
          </div>
        </div>
      </div>
    );
  }

  handleFieldClick = function(e) {
    if (e) {
      e.preventDefault();
    }
    if (this.props.disabled) {
      return;
    }
    window.addEventListener('scroll', this.handlePageScroll, true);
    window.addEventListener('wheel', this.handlePageScroll, true);
    this.setState({
      isFieldsPopoverOpen: true,
      anchorEl: this.fieldSelector.current,
    });
  }.bind(this);

  handleFieldClose = function() {
    window.removeEventListener('scroll', this.handlePageScroll, true);
    window.removeEventListener('wheel', this.handlePageScroll, true);
    this.setState({
      isFieldsPopoverOpen: false,
    });
  }.bind(this);

  handlePageScroll = function(e) {
    if (e.target && e.target.closest && e.target.closest('.field-selector-dropdown')) return;
    this.handleFieldClose();
  }.bind(this);

  handleFieldChange = function(field) {
    if (field.disable) return;
    this.props.onRuleChange({
      uuid: this.props.rule.uuid,
      name: field[ruleParts.RECORD_ENTRY_ATTRIBUTE] ? ruleParts.RECORD_ENTRY_ATTRIBUTE : ruleParts.FIELD_SUUID,
      value: field[ruleParts.RECORD_ENTRY_ATTRIBUTE] ? field[ruleParts.RECORD_ENTRY_ATTRIBUTE] : field.suuid,
      title: field.title
    });
    this.setState({
      isFieldsPopoverOpen: false,
      currentField: field
    });
  }.bind(this);

  handleOperatorChange = function(value) {
    this.props.onRuleChange({
      uuid: this.props.rule.uuid,
      name: ruleParts.OPERATOR,
      value: value,
      title: this.state.currentField.title
    });
  }.bind(this);

  handlePatternSelectorChange = function(value) {
    this.props.onRuleChange({
      uuid: this.props.rule.uuid,
      name: ruleParts.PATTERN,
      value: value,
      title: this.state.currentField.title
    });
  }.bind(this);

  handlePatternTextFieldChange = function(e) {
    this.props.onRuleChange({
      uuid: this.props.rule.uuid,
      name: ruleParts.PATTERN,
      value: e.target.value,
      title: this.state.currentField.title
    });
  }.bind(this);

  handlePatternDateChange = function(e, date) {
    this.props.onRuleChange({
      uuid: this.props.rule.uuid,
      name: ruleParts.PATTERN,
      value: date === dynamicDate ? date : (date == null ? '' : getTimestampFromDate(date)),
      title: this.state.currentField.title
    });
  }.bind(this);

  renderPatternComponent = function(pattern, currentField, operator, showTime) {
    var self = this;
    var t = this.props.t;
    var settingsOperators = this.props.settingsOperators;
    var disabled = this.props.disabled;

    var selectorPatternOptions = this.getSelectorPatternOptions(currentField);

    if (currentField.recordEntryAttribute === entryDetailsTypes.TIMESTAMP) {
      return (
        <DateTimePicker
          value={pattern}
          onChange={this.handlePatternDateChange}
          showTime={showTime}
          disabled={disabled}
        />
      );
    }

    switch (currentField.type) {
      case fieldsTypes.DATETIME: {
        return (
          <DateTimePicker
            value={pattern}
            onChange={this.handlePatternDateChange}
            showTime={showTime}
            disabled={disabled}
          />
        );
      }
      case fieldsTypes.BOOLEAN: {
        if (typeof pattern === 'string' && pattern) {
          pattern = JSON.parse(pattern);
        }
        // Build options for boolean selector
        var booleanOptions = selectorPatternOptions ? selectorPatternOptions.map(function(item) {
          var text = getBooleanText(
            settingsOperators[currentField.suuid].displayType,
            item
          );
          return { value: String(item), text: text };
        }) : [];

        return (
          <div className="settings-rule-pattern-selector">
            <SlateSelect
              options={booleanOptions}
              value={pattern !== undefined && pattern !== null ? String(pattern) : ''}
              onChange={function(val) {
                self.handlePatternSelectorChange(val === 'true');
              }}
              placeholder={t('settings:selectPattern')}
              searchable={false}
              disabled={disabled}
            />
          </div>
        );
      }
      case fieldsTypes.SELECTOR: {
        // Build options for selector
        var selectOptions = selectorPatternOptions ? selectorPatternOptions.map(function(item) {
          return { value: String(item), text: String(item) };
        }) : [];

        return (
          <div className="settings-rule-pattern-selector">
            <SlateSelect
              options={selectOptions}
              value={pattern !== undefined && pattern !== null ? String(pattern) : ''}
              onChange={this.handlePatternSelectorChange}
              placeholder={t('settings:selectPattern')}
              searchable={selectOptions.length > 5}
              disabled={disabled}
            />
          </div>
        );
      }
      default: {
        return (
          <div className="settings-rule-pattern-text">
            <SlateTextInput
              name={ruleParts.PATTERN}
              type="text"
              value={pattern || ''}
              onChange={this.handlePatternTextFieldChange}
              placeholder={t('settings:enterValue')}
              disabled={disabled}
            />
          </div>
        );
      }
    }
  }.bind(this);

  getSelectorPatternOptions = function(currentField) {
    var settingsOperators = this.props.settingsOperators;
    var result;

    if (currentField.type === fieldsTypes.BOOLEAN) {
      result = [true, false];
    }
    if (currentField.type === fieldsTypes.SELECTOR) {
      result = settingsOperators[currentField.suuid].options;
    }

    return result;
  }.bind(this);
}

var mapStateToProps = function(state) {
  return {
    settingsOperators: state.slateViews.settingsOperators,
    operatorsEntity: state.entities[entityNames.GET_SETTINGS_OPERATORS],
  };
};

export default withTranslation()(connect(mapStateToProps, null)(Rule));
